// extracted by mini-css-extract-plugin
export default {"body":"styles-module__body__src-labstep-web-core-Table-Simple-Body-_NMOO8"};